import { render, staticRenderFns } from "./upAction.vue?vue&type=template&id=6a3ae842&scoped=true&lang=html&"
import script from "./upAction.vue?vue&type=script&lang=js&"
export * from "./upAction.vue?vue&type=script&lang=js&"
import style0 from "./upAction.vue?vue&type=style&index=0&id=6a3ae842&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3ae842",
  null
  
)

export default component.exports